import PageHeader from "@/components/PageHeader";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useTimesheetEntriesBreadcrumb } from "../hooks/useTimesheetEntriesBreadcrumb";
import { useTimesheetShiftReportQuery } from "../hooks/useTimesheetShiftReportQuery";
import { TimesheetEntriesContractorsForm } from "./TimesheetEntriesContractorsForm";
import { ExportButton } from "@/components/export/ExportButton";
import { Module } from "@/constants";
import { useParams } from "react-router-dom";
import { FilterType } from "@/lib/filters";
import { buildExportQueryParams } from "@/lib/exportUtils";

export const TimesheetEntriesContractorsEditor = memo(() => {
  const { t } = useTranslation();
  const { shiftReportId } = useParams();

  const shiftReportQuery = useTimesheetShiftReportQuery();

  const breadcrumbItems = useTimesheetEntriesBreadcrumb({
    shiftReportQuery,
    appendLabel: t("timesheetEntries.contractors.breadcrumb"),
  });

  const exportQueryParams = useMemo(
    () =>
      buildExportQueryParams([
        {
          id: "shift_report_id",
          value: {
            value: shiftReportId,
            filter: FilterType.EqualsString,
          },
        },
      ]),
    [],
  );

  return (
    <>
      <PageHeader
        breadcrumbItems={breadcrumbItems}
        actions={[
          <ExportButton
            moduleName={Module.TimesheetEntriesContractors}
            queryParams={exportQueryParams}
          />,
        ]}
      />
      <TimesheetEntriesContractorsForm />
    </>
  );
});
